import { hrAndMinDuration } from "./datetime";

/**
 * ✅ This is part of the Cadmus standardised date/duration formatting.
 * Format a duration to a human-readable string.
 *
 * @example "1 hour 30 minutes"
 * @param minutes The duration in minutes
 */
export const formatCadmusDuration = (minutes: number): string => {
  /**
   * It would be nice if we can pass down the duration instead.
   * The problem being is that we don't know how to normalise the Duration object
   * to be in strictly minutes.
   *
   * eg. { weeks: 1, days: 3, hours: 2, minutes: 30 } => 10050 minutes
   */

  return hrAndMinDuration(minutes, { hr: " hr", min: " min" }, " ", false);
};
